import React from "react";
import Slider from "react-slick";
import { LoadingComp } from "../../components/LoadingComp";
import constant from "../../constant";

import "./style.scss";

export default class HomeHeydeskComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listings: [
        {
          id: 1,
          img: `${constant.phpHost}limage/004571993316/Meeting-rooms.jpg|700x550`,
          title: "Meeting rooms",
          content:
            "Browse all our meeting rooms, training rooms from premium business centres and coworking spaces and book instantly with Heydesk"
        },
        {
          id: 2,
          img: `${constant.phpHost}limage/004571993316/Conference-venues.jpg|700x550`,
          title: "Conference venues",
          content:
            "Need a venue for your conference browse all our list of stylish venues indoor and outdoor spaces with premium amenities"
        },
        {
          id: 3,
          img: `${constant.phpHost}limage/004571993316/Office-spaces.jpg|700x550`,
          title: "Office spaces",
          content:
            "Looking for an office space for your new location or startup, find all kinds of space in Heydesk - Private office, shared office space, private cabins"
        },
        {
          id: 4,
          img: `${constant.phpHost}limage/004571993316/Coworking-spaces.jpg|700x550`,
          title: "Coworking  spaces",
          content:
            "Are you a freelancer or individual working at home, need a space to stay away from all distractions, search and book a coworking space that meets your requirements"
        }
      ],
      show_loading: 0
    };
  }

  render() {
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      lazyLoad: "ondemand",
      initOnLoad: true,
      nextSlidesToPreload: 1,
      // fade: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1.2
          }
        }
      ]
    };

    return this.state.show_loading === 0 ? (
      <section id="home-explore-heydesk">
        <div className="title">
          <h1>Explore Heydesk</h1>
          <p>
            It's easy to find the right workspace at the right time, wherever
            you are
          </p>
        </div>
        <Slider {...settings}>
          {this.state.listings && this.state.listings.length > 0
            ? this.state.listings.map((listing, i) => {
                return (
                  <div className="Seach_desk" key={i}>
                    <div
                      className="space-image"
                      style={{
                        backgroundImage: `url(${listing.img})`
                      }}
                    />

                    <div className="text">
                      <h3>{listing.title}</h3>
                      <p>{listing.content}</p>
                    </div>
                  </div>
                );
              })
            : null}
        </Slider>
      </section>
    ) : (
      <LoadingComp />
    );
  }
}
